import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Tags from "../elements/Tags"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". . culture-1 culture-1" "culture-2 culture-2 culture-1 culture-1" "culture-2 culture-2 . ." ". . culture-3 culture-3" "culture-4 culture-4 . .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .culture-1 {
    grid-area: culture-1;
    align-self: flex-end;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  .culture-3 {
    grid-area: culture-3;
  }
  .culture-4 {
    grid-area: culture-4;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas: ". event-1 event-1 ." "event-2 event-2 culture-1 ." ". culture-2 culture-1 ." "culture-3 culture-2 . ." "culture-3 culture-4 . ." ". culture-4 . .";
  }
  @media (min-width: 1200px) {
  }
`

const March = () => {
  const data = useStaticQuery(graphql`
    query {
      marchEventOne: file(relativePath: { eq: "events/march/event-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 533, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marchEventTwo: file(relativePath: { eq: "events/march/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marchCultureOne: file(
        relativePath: { eq: "events/march/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marchCultureTwo: file(
        relativePath: { eq: "events/march/culture-2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 307, maxHeight: 400, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marchCultureThree: file(
        relativePath: { eq: "events/march/culture-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 307, maxHeight: 400, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      marchCultureFour: file(
        relativePath: { eq: "events/march/culture-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="march">
      <Grid>
        <Block className="event-1">
          <Photo img={data.marchEventOne} maxWidth={800} maxHeight={533} />
          <h4 style={{ maxWidth: 800 }}>
            We opened shop in beautiful Cape Town  🚠
          </h4>
        </Block>
        <Block className="event-2">
          <Photo img={data.marchEventTwo} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            We launched Loan Circle. A employer-employee lending platform.
          </h4>
          <Tags
            maxWidth={800}
            words={["react", "gatsbyjs", "graphql", "serverless"]}
          />
        </Block>
        <Block className="culture-1">
          <Photo img={data.marchCultureOne} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>Ed, one of our engineers, aged.</h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.marchCultureTwo} maxWidth={307} maxHeight={400} />
          <h4 style={{ maxWidth: 307 }}>
            Ashleigh joined the Geeks as a developer intern.
          </h4>
        </Block>
        <Block className="culture-3">
          <Photo img={data.marchCultureThree} maxWidth={307} maxHeight={400} />
          <h4 style={{ maxWidth: 307 }}>
            Andrea joined too as a developer intern.
          </h4>
        </Block>
        <Block className="culture-4">
          <Photo img={data.marchCultureFour} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            Christina, our office assistant, celebrated her birthday.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default March
